import { Component, EventEmitter, Output, Input, ElementRef, AfterViewInit, ViewChild, Renderer2 } from '@angular/core';
import { ColorData } from './color-data.entity';
import { ModelService } from 'src/app/services/model.service';



@Component({
	selector: 'app-color',
	templateUrl: './color.component.html',
	styleUrls: ['./color.component.scss']
})
export class ColorComponent implements AfterViewInit {
	@Output() loaded = new EventEmitter<ColorData[]>();
	@Output() clickColor = new EventEmitter<ColorData>();
	// Idioma
	@Input() idioma: string = 'es';

	@ViewChild('SVGColoresRivisa') SVGColoresRivisa: ElementRef;

	// Array de colores sacada de MongoDB lista 'colors'.
	public colors: ColorData[] = [
		{ _id: '595bb930060cda18c1334ed0', ral: 0, hex: '#DADADA', name: 'galvanizado', check: true, desc: { es: 'Galvanizado', ca: 'Galvanizat', en: 'Galvanized', fr: 'Galvanizado' } },
		{ _id: '595bb930060cda18c1334ed2', ral: 6005, hex: '#004A39', name: 'verde', check: true, desc: { es: 'Verde', ca: 'Verd', en: 'Green', fr: 'Vert' } },
		{ _id: '595bb930060cda18c1334ed4', ral: 1018, hex: '#FFD500', name: 'zinc', check: true, desc: { es: 'Amarillo de zinc', ca: 'Groc de zinc', en: 'Zinc yellow', fr: 'Jaune zinc' } },
		{ _id: '595bb930060cda18c1334ed6', ral: 3005, hex: '#751632', name: 'vino', check: true, desc: { es: 'Rojo vino', ca: 'Vermell vi', en: 'Wine red', fr: 'Rouge vin' } },
		{ _id: '595bb930060cda18c1334ed8', ral: 3020, hex: '#D20A11', name: 'rojo', check: true, desc: { es: 'Rojo tráfico', ca: 'Vermell tràfic', en: 'Traffic red', fr: 'Rouge signalisation' } },
		{ _id: '595bb930060cda18c1334eda', ral: 0, hex: '#1B1B1A', name: 'oxiron', check: true, desc: { es: 'Oxirón', ca: 'Oxiron', en: 'Oxiron', fr: 'Oxiron' } },
		{ _id: '595bb930060cda18c1334edc', ral: 9006, hex: '#A7A2A0', name: 'metalico', check: true, desc: { es: 'Aluminio blanco (Gris metálico)', ca: 'Alumini blanc (Gris metàlic)', en: 'White aluminium (Metallic gray)', fr: 'Aluminium blanc (Gris métallisé)' } },
		{ _id: '595bb930060cda18c1334ede', ral: 7030, hex: '#96948B', name: 'piedra', check: true, desc: { es: 'Gris piedra', ca: 'Gris pedra', en: 'Stone grey', fr: 'Gris pierre' } },
		{ _id: '595bb930060cda18c1334ee0', ral: 9005, hex: '#00181B', name: 'negro', check: true, desc: { es: 'Negro intenso', ca: 'Negre intens', en: 'Jet black', fr: 'Noir foncé' } },
		{ _id: '595bb930060cda18c1334ee2', ral: 5001, hex: '#004161', name: 'azul', check: true, desc: { es: 'Azul verdoso', ca: 'Blau verdós', en: 'Green blue', fr: 'Bleu vert' } },
		{ _id: '5b16ab91ca1df794edf82088', ral: 9016, hex: '#FFFFFF', name: 'blanco', check: true, desc: { es: 'Blanco', ca: 'Blanc', en: 'White', fr: 'Blanc' } },
		{ _id: '5b16acd5ca1df794edf82198', ral: 7016, hex: '#24353F', name: 'antracita', check: true, desc: { es: 'Gris Antracita', ca: 'Gris Antracita', en: 'Anthracite Gray', fr: 'Gris Anthracite' } }
	];

	public estado: boolean = false;
	public show: boolean = false;
	public top: string = '0px';
	public left: string = '0px';

	private SVG: ElementRef;
	private svgPaths: ElementRef[];
	private svgTitles: ElementRef[];

	constructor(
		private renderer: Renderer2,
		public modelService: ModelService
		) { }

	ngAfterViewInit() {
		this.SVG = new ElementRef(<Element>this.SVGColoresRivisa.nativeElement.getElementsByTagName('svg')[0]);
		this.svgPaths = [];
		this.svgTitles = [];
		let ps = this.SVG.nativeElement.getElementsByTagName('path');
		for (let i = 0; i < ps.length; i++) {
			var aux = new ElementRef(<Element>ps[i]);
			this.renderer.listen(aux.nativeElement, 'click', (event) => { this.selectColor(event) });
			this.svgTitles.push(new ElementRef(<Element>aux.nativeElement.children[0]));
			this.svgPaths.push(aux);
		}
		this.update();
		this.modelService.getLanguage().onLanguageLoaded.subscribe(() => this.update())
	}

	public updateColors() { }

	// Activa o desactiva el color.
	public activoColor(index: number, action: boolean) {
		if (index > -1 && index < this.colors.length) {
			this.colors[index].check = action;
		}
		this.update();
	}

	// Actualiza el icono y textos.
	private update() {
		let iTitle = 0;
		for (let p of this.svgPaths) {
			let i = parseInt(p.nativeElement.id.replace('svgColor', ''));
			const ret: ColorData = this.colors[i];
			p.nativeElement.style = "fill:" + ret.hex + "; cursor:" + ((ret.check) ? "pointer;" : "not-allowed;");
			this.svgTitles[iTitle].nativeElement.textContent = ret.desc[this.modelService.languageService.currentLanguage];
			iTitle++;
		}
	}

	// Devuelve true si el color está activo.  public isDisabled (index: number): boolean
	// {if (index > -1 && index < this.colors.length) { return this.colors[index].check; }
	// return false;  }
	// Lanza el evento click si el color está activo.
	//public selectColor(key: number) {
	public selectColor(event: any) {
		var i = parseInt(event.target.id.replace('svgColor', ''));
		const ret: ColorData = this.colors[i];
		if (ret.check) {
			this.clickColor.emit(ret);
			this.show = false;
		}
	}

	public Show(value: boolean) {
		this.show = value;
	}
}
